import React from 'react';
import { LinearProgress, Paper, Stack, Table, TableContainer, TablePagination } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { MuiTableBody } from './MUITableBody';
import { MuiTableHeader } from './MUITableHeader';
import { MUIBaseEntity, MUITableProps } from './types';

export const MUITable = <TableEntity extends MUIBaseEntity>({
  columns,
  sorting,
  tableData,
  isLoading,
  pagination,
  onRowClick,
  hover = false,
  stickyHeader = false,
}: MUITableProps<TableEntity>) => {
  const classes = useStyles();

  const handlePageChange = (page: number) => {
    pagination.onChange({
      page: page + 1,
    });
  };

  const handleRowsPerPageChange = (perPage: string) => {
    pagination.onChange({
      page: 1,
      perPage: parseInt(perPage, 10),
    });
  };

  return (
    <Stack height="100%">
      <TableContainer /* component={Paper} */ className={classes.container + ' tableContainer'}>
        {isLoading && !!tableData.length && <LinearProgress color="primary" className={classes.loading} />}

        <Table stickyHeader={stickyHeader}>
          <MuiTableHeader<TableEntity> columns={columns} sorting={sorting} />

          <MuiTableBody<TableEntity>
            hover={hover}
            columns={columns}
            tableData={tableData}
            isLoading={isLoading}
            pagination={pagination}
            onRowClick={onRowClick}
          />
        </Table>
      </TableContainer>

      <Paper>
        <TablePagination
          component="div"
          count={pagination.total}
          colSpan={columns.length}
          page={pagination.page - 1}
          rowsPerPage={pagination.perPage}
          rowsPerPageOptions={[5, 15, 25, 50]}
          onPageChange={(_, page) => handlePageChange(page)}
          onRowsPerPageChange={({ target: { value } }) => handleRowsPerPageChange(value)}
        />
      </Paper>
    </Stack>
  );
};

const useStyles = makeStyles({
  container: {
    height: '100%',
    position: 'relative',
  },
  loading: {
    top: 0,
    left: 0,
    height: 2,
    zIndex: 3,
    width: '100%',
    position: 'absolute',
  },
});
